import { AfterViewInit, Component, Input, OnInit, ViewChild } from "@angular/core";
import { ClaimFormModel, ClaimsViewModel, ClaimsViewSearchParams } from "./model/claims-view.model";
import { DataElement, PaginationParams } from "@shared/models/common";
import { TableComponent } from "src/app/shared/components/ui/table/table.component";
import { ClaimsViewService } from "./service/claims-view.service";
import { AppState } from "@shared/redux/store";
import { NgRedux } from "@shared/redux/redux-compatibility.service";
import { Catalog, ReferenceDocument } from "@shared/models/cat.model";
import { TabIdList } from "@shared/models/tab.model";
import { DocMetadataHandler } from "../add-doc-metadata/services/add-doc-metadata.interface";
import { ClaimDocMetadataHandler } from "../add-doc-metadata/services/add-doc-metadata-claim.interface";
import { trigger } from "@angular/animations";
import { SharedService } from "@shared/services/shared.service";
import { TranslateService } from "@ngx-translate/core";
import { keyCodes } from "@shared/models/key-codes.model";
import { ClaimBulkMetadata } from "./claim-bulk-metadata/claim-bulk-metadata.component";



@Component({
    selector: 'claims-view',
    templateUrl: './claims-view.component.html',
    styleUrls: ['./claims-view.component.scss'],
    providers: [
        {
        provide: ClaimsViewService, useClass: ClaimsViewService
         },
         {
            provide: ClaimDocMetadataHandler, useClass: ClaimDocMetadataHandler
         }
    ],
    standalone: false
})
export class ClaimsViewComponent implements OnInit, AfterViewInit {


    loading = false;
    displayClaims: ClaimsViewModel[] = [];
    searchParams: ClaimsViewSearchParams = new ClaimsViewSearchParams();
    rowsPerPage: number = 50;
    pageNumber: number = 1;
    totalRecords: number = 0;
    tabIdList: TabIdList | undefined = undefined;
    //editMetadata: boolean = false;
    claimToEdit: ClaimsViewModel | null = null;
    loadingClaimChanges: boolean = false;
    filterText: string = '';
    filterClaimType: DataElement = null;
    selectedClaims: ClaimsViewModel[] = [];
    @ViewChild('tblEntries') tblEntries: TableComponent;
    @ViewChild('bulkClaimMetadata') bulkClaimMetadata: ClaimBulkMetadata | null = null;
    selectedActionId: string | null = null;

    selectAll: boolean = false;
    actionList = [
        { id: 'approve', text: this.translateService.instant('translate.general.approveSelected') },
        { id: 'setToDraft', text: this.translateService.instant('translate.general.setToDraftSelected') },
        { id: 'delete', text: this.translateService.instant('translate.general.deleteSelected') },
        { id: 'bulk-edit-metadata', text: this.translateService.instant('translate.general.claims-view.bulk-edit-metadata') }
    ]
    filterStatus: DataElement = null;
    claimStatusList: DataElement[] = [
        new DataElement('DRAFT', 'DRAFT'),
        new DataElement('APPROVED', 'APPROVED'),
    ];
    displayClaimForm: boolean = false;
    mode: 'create' | 'edit' | 'view' = 'create'
    claimFormModel: ClaimFormModel | null = null;
    // ref docs loaded together with claim details (null in create mode - claim form loads them)
    claimFormRefDocs: ReferenceDocument[] | null = null;
    bulkEditMetadata: boolean = false;

    constructor(private claimsViewService: ClaimsViewService, 
        private ngRedux: NgRedux<AppState>,
        private docMetadataHandler: ClaimDocMetadataHandler,
        private sharedService: SharedService,
        private translateService: TranslateService) {

            this.tabIdList = this.ngRedux.getState().ui_tabIdList;

    }
    
    ngOnInit(): void {
    
    }
    ngAfterViewInit(): void {

        this.loadEntries(true);
    }
    get curCat(): Catalog | undefined {

        return this.ngRedux.getState().curCat;
    }
    get numberOfRows(): number {
        return this.displayClaims?.length || 0;
    }


    get contentTypeList(): DataElement[] {
        return [
            new DataElement('CLAIM', 'Claim'),
            new DataElement('TEXT_CONTENT', 'Text content'),
        ];
    }

    get displayClearFilter(): boolean {
        return (this.filterText != null && this.filterText !== '') || this.filterClaimType != null || this.filterStatus != null;
    }

    onFilterKeyPress(e: any) {
        if (e.keyCode == keyCodes.enter) {
            this.loadEntries(true);
        }
    }

    onFieldValueChanged(e?: any) {
        if (e != null && e.originalEvent) (e.originalEvent as MouseEvent).stopPropagation();
        this.loadEntries(true);
    }

    clearFilter() {
        this.filterText = '';
        this.filterClaimType = null;
        this.filterStatus = null;
        this.loadEntries(true);
    }

    loadEntries(newSearch: boolean) {
        
        let pageNum = 1;
        if (newSearch) {
            pageNum = 1;
            this.searchParams.rangeFrom = 0;
            this.searchParams.rangeTo = this.rowsPerPage;
            if (this.tblEntries) {
                this.tblEntries.first = 0;
                if (this.tblEntries.tableRef) {
                    this.tblEntries.tableRef.first = 0;
                }
            }
        } else {
            
            if (this.searchParams.rangeFrom == undefined || this.searchParams.rangeFrom == this.totalRecords) {
                return;
            }
            pageNum = Math.floor(this.searchParams.rangeFrom / this.rowsPerPage) + 1;
        
        }
        this.loading = true;
        const filterText = this.filterText?.trim() || undefined;
        const claimType = this.filterClaimType?.id || undefined;
        const status = this.filterStatus?.id || undefined;
        this.selectedClaims = [];
        this.claimsViewService.getClaims(this.catVersionId, pageNum, this.rowsPerPage, this.lang, filterText, claimType, status).subscribe((data) => {

            this.displayClaims = data.claims;
            this.totalRecords = data.claimsStats.totalCount;
            this.loading = false;
            if (newSearch && this.tblEntries) {
                setTimeout(() => {
                    this.tblEntries.first = 0;
                    if (this.tblEntries.tableRef) this.tblEntries.tableRef.first = 0;
                }, 0);
            }
        }, (err) => {

            this.loading = false;
            this.displayClaims = [];
            this.totalRecords = 0;
        });
    }
    onPagination(event: PaginationParams) {

        if (event.rangeFrom == undefined || event.rangeTo == undefined) {

            return;
        }

        if (
            !this.displayClaims ||
            (event.rangeFrom - 1 == this.searchParams.rangeFrom &&
                event.rangeTo == this.searchParams.rangeTo)
        ) {
            return;
        }
        this.searchParams.rangeFrom = event.rangeFrom - 1;
        this.searchParams.rangeTo = event.rangeTo;
        this.loadEntries(false);
    }

    edit(e: any, claimsView: ClaimsViewModel) {
       
        if (e) {
            
            (e as MouseEvent).stopPropagation();
        }
       


        this.claimsViewService.getClaimDetails(claimsView.claimId, this.lang, this.catVersionId).subscribe((claimDetails) => {

            this.displayClaimForm = true;
            this.mode = 'edit';
            this.claimFormModel = claimDetails.claim;
            this.claimFormRefDocs = claimDetails.refDocs;
        });

        // get pre select values
    }

    view(e: any, claimsView: ClaimsViewModel) {
        
        if (e) {
            
            (e as MouseEvent).stopPropagation();
        }


      this.claimsViewService.getClaimDetails(claimsView.claimId, this.lang, this.catVersionId).subscribe((claimDetails) => {

            this.displayClaimForm = true;
            this.mode = 'view';
            this.claimFormModel = claimDetails.claim;
            this.claimFormRefDocs = claimDetails.refDocs;
      });



    }
    delete(e:any, claimsView: ClaimsViewModel) {

        if (e) {

            (e as MouseEvent).stopPropagation();
        }

        let validationStr = this.translateService.instant(
            'translate.cat.deleteClaim'
        );
        this.sharedService.emitPopupchReceivedEvent({
            title: 'translate.validation.confirm',
            icon: 'exclamation-triangle',
            subTitle: validationStr,
            keep: false,
            approve: () => {
                
                this.loading = true;
                this.claimsViewService.deleteClaim(claimsView.claimId).subscribe(() => {

                    this.loading = false;
                    this.displayClaims = this.displayClaims.filter((claim) => claim.claimId !== claimsView.claimId);

                }, error => {
                    this.loading = false;
                })
            },
            onClose: () => {
                this.loading = false;
            }
        });

        
    }

    approve(e: any, claimsView: ClaimsViewModel) {
        if (e) (e as MouseEvent).stopPropagation();
        let validationStr = this.translateService.instant('translate.cat.approveClaim');
        if (!validationStr || validationStr === 'translate.cat.approveClaim') validationStr = 'Approve this draft claim?';
        this.sharedService.emitPopupchReceivedEvent({
            title: 'translate.validation.confirm',
            icon: 'exclamation-triangle',
            subTitle: validationStr,
            keep: false,
            approve: () => {
                this.loading = true;
                this.claimsViewService.setClaimStatus(claimsView.claimId).subscribe(() => {
                    this.loading = false;
                    claimsView.status = 'APPROVED';
                }, () => { this.loading = false; });
            },
            onClose: () => { this.loading = false; }
        });
    }

    draft(e: any, claimsView: ClaimsViewModel) {
        if (e) (e as MouseEvent).stopPropagation();
        let validationStr = 'Set this claim to draft?';
        this.sharedService.emitPopupchReceivedEvent({
            title: 'translate.validation.confirm',
            icon: 'exclamation-triangle',
            subTitle: validationStr,
            keep: false,
            approve: () => {
                this.loading = true;
                this.claimsViewService.setClaimStatus(claimsView.claimId, 'DRAFT').subscribe(() => {
                    this.loading = false;
                    claimsView.status = 'DRAFT';
                }, () => { this.loading = false; });
            },
            onClose: () => { this.loading = false; }
        });
    }

    displayValues(metadata: {fieldLabel: string; fieldName: string; fieldValues: string[]}) {

        return metadata.fieldValues.join(",");
    }

/*     saveMetadataChanges() {

        if (!this.claimToEdit) {
            
            return;
        }

        let metadataToAdd = this.docMetadataHandler.getDocMetadataToAdd();

        if (!metadataToAdd) {

            return;
        }
        if (Object.keys(metadataToAdd).length == 0) {

            return;

        }
        // send req
        this.loadingClaimChanges = true;
        this.claimsViewService.saveClaimMetadata(this.claimToEdit.claimId, metadataToAdd).subscribe(() => {
            
            this.loadingClaimChanges = false;
            this.editMetadata = false;
            // update claim metadata with added metadata
            if (this.claimToEdit) {
                this.claimToEdit.metadata = this.docMetadataHandler.updateClaimMetadata(metadataToAdd);
            }
        }, (error)  => {

            this.loadingClaimChanges = false;
        });

    } */

/*     cancelEditMetadata() {
        
        this.editMetadata = false;
    } */

    get enableSaveMetadataChanges(): boolean {

        return this.docMetadataHandler.enableSaveMetadataChanges();
    }

    get envId() {

        return this.ngRedux.getState().curEnv?.id;
    }


    // this wont be undefined since we are in library
    get catSystemVersion() {

        return this.ngRedux.getState().curCat?.systemVersion;
    }

    get lang() {

        return this.ngRedux.getState().ui_lang;
    }

    get catVersionId() {

        return this.ngRedux.getState().curCat?.catVersionId;
    }

    isSelected(claim: ClaimsViewModel): boolean {  
        return claim.isSelected;
    }
    
    onChangeSelection(claim: ClaimsViewModel, event: MouseEvent) {
        
        claim.isSelected = (event.target as HTMLInputElement).checked;
        /// add or remove from selected claims in service
        if (claim.isSelected) {
            this.selectedClaims.push(claim);
        } else {
            this.selectedClaims = this.selectedClaims.filter((c) => c.claimId !== claim.claimId);
        }

    }
    onToggleSelectAll() {
        this.selectedClaims = this.selectAll ? [...this.displayClaims] : [];
        this.displayClaims.forEach((claim) => {
            claim.isSelected = this.selectAll;
        });
    }
    onActionSelected() {
        if (this.selectedActionId == null) {  
            return;
        }
        //this.selectedAction = this.a
        // display confirmation dialog for delete, approve or setToDraft
        let message = '';
        let obs$: any = null;

        if (this.selectedActionId === 'delete') {
            message = this.translateService.instant('translate.general.deleteSelectedClaims');
            obs$ = this.claimsViewService.deleteClaims(this.selectedClaims);
        } else if (this.selectedActionId === 'approve') {
            message = this.translateService.instant('translate.general.approveSelectedClaims');
            obs$ = this.claimsViewService.setBatchClaimStatus(this.selectedClaims, 'APPROVED');
        } else if (this.selectedActionId === 'setToDraft') {
            message = this.translateService.instant('translate.general.setToDraftSelectedClaims') || 'Are you sure that you want to set the selected claims to draft?';
            obs$ = this.claimsViewService.setBatchClaimStatus(this.selectedClaims, 'DRAFT');
        } else if (this.selectedActionId == 'bulk-edit-metadata') {

            //message = this.translateService.instant('translate.general.editMetadataForSelectedDocuments') || 'Are you sure that you want to edit metadata for selected documents?';
            //obs$ = this.claimsViewService.setBatchClaimStatus(this.selectedClaims, 'DRAFT');
            //
            const hasApprovedClaim = this.selectedClaims.find(claim => claim.status == 'APPROVED');
            if (hasApprovedClaim) {
                const errorMessage = this.translateService.instant('translate.general.bulk-claim-metadata.selectionError');
                this.sharedService.emitPopupchReceivedEvent({
                    title: 'translate.alert.infoTitle',
                    icon: 'exclamation-triangle',
                    subTitle: errorMessage,
                    keep: false,
                    onClose: () => {
                        
                        this.selectedActionId = null;

                    },
                });                
                
            } else {
                this.bulkEditMetadata = true;
                //this.selectedActionId = null;
            }
            return;
        }

        this.sharedService.emitPopupchReceivedEvent({
            title: 'translate.validation.confirm',
            icon: 'exclamation-triangle',
            subTitle: message,
            keep: false,
            approve: () => {    
                if (obs$) {
                    obs$.subscribe(() => {
                        this.loadEntries(false);
                        this.selectedActionId = null;
                    }, (error) => {
                        this.selectedActionId = null;
                    });
                }
            }, onClose: () => {
                this.selectedActionId = null;
            }
        });
    }

    saveBulkMetadataChanges() {
        if (!this.selectedClaims || this.selectedClaims.length == 0 || !this.bulkClaimMetadata) {
            return;
        }
        this.selectedActionId = null;
        this.loadingClaimChanges = true;

        this.claimsViewService.saveBulkClaimChanges(this.selectedClaims.map((claim) => claim.claimId), this.bulkClaimMetadata.docMetadataToAdd).subscribe(() => {
            this.loadingClaimChanges = false;
            this.bulkEditMetadata = false;
            this.loadEntries(true);
        },
        (error) => {
        this.bulkEditMetadata = false;
    });
    }

    get enableBulkMetadataChanges() {

        return this.bulkClaimMetadata?.canSubmit() || false;
    }
    cancelEditBulkMetadata() {
        this.bulkEditMetadata = false; 
        this.selectedActionId = null
    }
}